import React, {useEffect, useState} from 'react';
import {sendKlaviyoIdentify, withKlaviyo} from "../ExternalServices/Klaviyo/KlaviyoHelpers";
import {readKlaviyoFormHistory, trapKlaviyoFormEvents} from "./klaviyoFormStatus";
import {sendKlaviyoPageEvents} from "./pageEvents";

const isDev = (process.env.NODE_ENV == 'development');

/**
 * On startup, update Klaviyo with an "identify" action
 * ...and also send current page info.
 *
 * 2025-08 use new Klaviyo Form Events to detect form appearances
 * and signups.
 *
 * @param cartCode
 * @param customerVehicle
 * @param controllerName
 * @param user
 * @param props
 * @returns {null}
 * @constructor
 */
export default function KlaviyoInformant({
  cartCode, customerVehicle, controllerName, user, ...props
}) {

  const [sentEvents, setSentEvents] = useState(false);
  const [history, setHistory] = useState(readKlaviyoFormHistory());

  function klaviyoCallback(event) {
    console.log("KLAVIYO CALLBACK: ", event);
    setHistory(readKlaviyoFormHistory());
  }

  // Run once. On startup, track Klaviyo form events
  useEffect(() => {
    trapKlaviyoFormEvents({callback: klaviyoCallback});
  }, []);

  // Run every time the user becomes known.
  useEffect(() => {
    // UGLY KLUGE -
    // Do not run this when in subscriptions controller; it has its own
    // KlaviyoUnsubscribeApp to do the identify.
    if (controllerName === 'subscriptions')
      return;

    console.log("KlaviyoInformant: user is " + JSON.stringify(user));

    // 2025-08 - send events even when user is empty; identify() is optional!
    // if (isEmpty(user))
    //   return;

    // put everything inside a withKlaviyo block so it runs synchronously
    withKlaviyo(k => {

      // 2025-08 - OK to call with null user
      sendKlaviyoIdentify({
        user, cartCode, customerVehicle,
        attrs: {_debug: 'KlaviyoInformant'}
      });

      // send page events once
      if (!sentEvents) {
        setSentEvents(true);
        sendKlaviyoPageEvents();
      }
    })

  }, [user, cartCode, customerVehicle]);

  const handleTestClick = () => {
    window.klaviyo.openForm('RBnmF8');  // EMAIL
    // window.klaviyo.openForm('U9F3rL'); // SMS

    // sms window._klOnsite = window._klOnsite || [];
    // window._klOnsite.push(['openForm', 'U9F3rL']);
  }


  // if (isDev) {
  //   return <div className="debug">
  //     <div className="container">
  //       KlaviyoInformant!
  //       <button className="mx-4 p-2 bg-brand-orange text-white" onClick={handleTestClick}>Klaviyo Form Test</button>
  //       <pre>{JSON.stringify(history, null, 2)}</pre>
  //     </div>
  //   </div>
  // }

  // speak no evil
  return null;
}
